import { useEffect, useState } from 'react';
import {
    UserOutlined,
    HomeOutlined,
} from "@ant-design/icons";
import '../style/layout.css';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { getRoutes } from '../router';
import { Avatar, Popover, Button, Layout, Menu, ConfigProvider, Space, Breadcrumb } from "antd";
import { deleteCookie } from '../utils/cookie';
import { Typography } from "antd";
import { MainLayoutUrl } from "../router/router_path";

const { Header, Content, Footer, Sider } = Layout;

const MainLayout = ({menus, accountName}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const breadItems = () => {
        let paths = getActivedPaths(null, menus, defaultKey());
        const routes = getRoutes();
        let arrs = paths.map(item => {
            let route = routes.find(rt => rt.key === item.key);
            if (route) {
                return { title: item.label, path: route.path }
            }
            return { title: item.label }
        });

        return [{ title: <HomeOutlined /> }, ...arrs];
    };

    const menuChangeHandle = (evt) => {
        let paths = evt.keyPath;
        const totalRoutes = getRoutes();
        const route = totalRoutes.find(item => item.key === paths[0]);
        if (!route) return;
        const targetRoute = route.path;
        if(targetRoute !== location.pathname) {
            navigate(targetRoute);
        }
    }

    const logoutHandle = () => {
        deleteCookie('user-token');
        window.localStorage.removeItem('rjwt');
        // window.location.reload();
        navigate('/login', {replace: true});
    }

    const defaultKey = () => {
        const pathArr = location.pathname.split('/');
        if (!isNaN(pathArr[pathArr.length - 1])) {
            pathArr[pathArr.length - 1] = ':id'
        }
        let pathname = pathArr.join('/');
        const routes = getRoutes();
        const route = routes.find(item => pathname.includes(item.path));
        if (route) {
            return route.selectedKey;
        }
        return '';
    };

    const defaultOpenKey = () => {
        let keys = getActivedPaths(null, menus, defaultKey()) ?? [];
        return keys.map(item => item.key);
    }

    const getActivedPaths = (parentKey, routeArr, pathKey) => {
        let keys = [];
        for (let i = 0; i <= routeArr.length - 1; i++) {
            let route = routeArr[i];
            let data = { key: route.key, label: route.label }
            if (route.key === pathKey) {
                keys = parentKey ? [parentKey, data] : [data];
                break;
            } else if (route.children && route.children.length > 0) {
                const chKeys = getActivedPaths(data, route.children, pathKey);
                if (chKeys.length > 0) {
                    keys = parentKey ? [parentKey, ...keys, ...chKeys] : [...keys, ...chKeys];
                    break;
                }
            }
        }
        return keys;
    }

    const activeMenuKey = defaultKey();
    const activeParentKeys = JSON.stringify(defaultOpenKey().filter(key => key !== activeMenuKey));
    const [openKeys, setOpenKeys] = useState(() => JSON.parse(activeParentKeys));
    useEffect(() => {
        // Reveal the active page after a move or navigation without collapsing
        // other directories the user opened manually.
        const parents = JSON.parse(activeParentKeys);
        setOpenKeys(current => [...new Set([...current, ...parents])]);
    }, [activeParentKeys]);

    const AccountPanel = () => {
        return (
            <div>
                <Button onClick={logoutHandle} type="text">Sign out</Button>
            </div>
        );
    }

    return (
        <ConfigProvider theme={{
            token: {
                colorTextDisabled: '#666',
                colorBgContainerDisabled: '#f5f5f5'
            },
            components: {
                Menu: {
                    darkItemSelectedBg: 'rgba(255, 255, 255, 0.15)'
                },
                Layout: {
                    headerBg: '#002766',
                },
                Button: {
                    borderRadius: 0
                }
            }
        }}>
            <Layout style={{ height: '100vh' }}>
                <Header className="wrapper-header" style={{ padding: 0 }}>
                    <div className="inc-header">
                        <img src="/images/logo.png" style={{ width: 36, height: 36, marginRight: 8, borderRadius: 20 }} />
                        Go CMS
                    </div>
                    <div style={{ marginRight: 20 }}>
                        <Popover trigger={'click'} placement="bottomRight" content={AccountPanel}>
                            <Space size={4}>
                                <Avatar size={24} style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
                                <Typography.Text style={{ color: 'white' }}>Hello, {accountName}</Typography.Text>
                            </Space>
                        </Popover>
                    </div>
                </Header>
                <Layout>
                    <Sider
                        theme="dark"
                        width={240}
                        breakpoint="lg"
                        collapsedWidth="0"
                        onBreakpoint={broken => {
                            // console.log(broken);
                        }}
                        onCollapse={(collapsed, type) => {
                            // console.log(collapsed, type);
                        }}
                    >
                        <div style={{height: '100%', overflowY: 'auto'}}>
                            <div style={{ height: 24 }} />
                            <Menu
                                items={menus}
                                theme="dark"
                                mode="inline"
                                selectedKeys={[activeMenuKey]}
                                openKeys={openKeys}
                                onOpenChange={setOpenKeys}
                                onClick={menuChangeHandle}
                            />
                        </div>
                    </Sider>
                    <Layout>
                        <Breadcrumb style={{ margin: '16px 16px 0 16px' }} items={breadItems()} />
                        <Content style={{ margin: '24px 16px 0', overflowY: 'auto' }} className={location.pathname === MainLayoutUrl.dashboard.index.path ? '' : 'site-layout-background'}>
                            <Outlet />
                        </Content>
                        <Footer style={{ textAlign: 'center' }}>Go Wallet©2024 Created by ADDX</Footer>
                    </Layout>
                </Layout>
            </Layout>
        </ConfigProvider>
    )
}

export default MainLayout;